var map = {
	"./item01.png": "6a3d",
	"./item01.svg": "4bd5",
	"./item02.png": "c929",
	"./item02.svg": "677a",
	"./item03.png": "8dd3",
	"./item03.svg": "5177",
	"./item04.png": "3af2",
	"./item04.svg": "a6d9",
	"./item05.png": "07f7",
	"./item05.svg": "27cd",
	"./mark.svg": "52f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2b4a";